import { createSelector } from '@reduxjs/toolkit';

import { selectComplaintsState } from './selectComplaintsState';

export const selectComplaintOfferId = createSelector(selectComplaintsState, state => state.offerId);
